
import { endChat } from "../fetch";

export const onHandleChatEnd = async (sessions, endSession, chatData) => {
    // Filtra las sesiones que están actualmente activas (sin finalizar)
    let activeSessions = sessions.filter(session => session.Fin === null);

    // Comprueba si hay alguna sesión activa distinta de la sesión que se desea finalizar
    let otherActiveSessions = activeSessions.filter(session => session.IdSession !== endSession.IdSession);

    console.log("Sesiones activas:", activeSessions);
    console.log("Otras sesiones activas distintas de la sesión que se desea finalizar:", otherActiveSessions);

    if (otherActiveSessions.length === 0) {
        endChat(chatData)
    }
};